import {
  Component,
  OnInit,
  Input,
  OnChanges,
  ChangeDetectionStrategy,
  ViewChild,
  ChangeDetectorRef,
} from "@angular/core";
import { MapUtils } from "src/app/shared/utils/map-utils";
import { Coordenada } from "src/app/models/entities/coordenada";
import { CapaSegmentosDTO } from "src/app/models/dtos/capa-segmentos-dto";
import { Segmento } from "src/app/models/entities/segmento";
import { LevantamientoSeleccionadoDTO } from "src/app/models/dtos/levantamiento-seleccionado-dto";
import { NgbModalRef, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ArchivoCoordenada } from "src/app/models/entities/archivo-coordenada";
import { MapsAPILoader } from "@agm/core";
import {} from "googlemaps";
import { InfoWindow } from "@agm/core/services/google-maps-types";
import { DateUtils } from "src/app/shared/utils/date-utils";
import { CatalogoService } from "src/app/services/catalogo.service";
import { RutaCatalogoEnum } from "src/app/shared/enums/ruta-catalogo.enum";
import { take } from "rxjs/operators";
import { ElementoCatalogo } from "src/app/models/entities/elemento-catalogo";
import { AvanceDTO } from "src/app/models/dtos/avance-dto";
declare const google: any;

@Component({
  selector: "levantamiento-actual",
  templateUrl: "./levantamiento-actual.component.html",
  styleUrls: ["./levantamiento-actual.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LevantamientoActualComponent implements OnInit, OnChanges {
  @ViewChild("modalGaleria")
  public modalGaleria: NgbModalRef;
  public refModalGaleria: NgbModalRef;
  public avanceSeleccionado: AvanceDTO;

  @Input("datosObra")
  public datosObra: LevantamientoSeleccionadoDTO;
  public map: any;
  public iconoMultimedia: any = {
    url: "../../../../../assets/img/iconos/icono-multimedia.png",
    scaledSize: {
      width: 20,
      height: 20,
    },
  };
  public iconoPuente: any = {
    url: "../../../../../assets/img/iconos/icono-puente.png",
    scaledSize: {
      width: 20,
      height: 20,
    },
  };
  public iconoCoordenada: any = {
    url: "../../../../../assets/img/iconos/coordenada-disponible.png",
    scaledSize: {
      width: 5,
      height: 5,
    },
  };

  public iconoInicioFin: any;
  public readonly CAPA_PROYECTO_PROCESO: string = "0";
  public readonly CAPA_PROYECTO_PLANEACION: string = "4";
  public readonly CAPA_META_ACTUAL: string = "1";
  public readonly CAPA_COMPLETADO: string = "2";
  public readonly CAPA_ESTRUCTURA: string = "5";
  public readonly KEY_COLOR_CAPA_COMPLETADO: string = "2";
  public hexColorCapaCompletado: string = "";
  public archivosSeleccionados: ArchivoCoordenada[];
  public coordenadaInicial: Coordenada;
  public coordenadaFinal: Coordenada;
  public coordenadaInfoWindow: Coordenada;
  public infoWindowActual: InfoWindow = null;
  public infoWindowAbierto = false;
  public COLOR_PARA_RESALTAR: string = "#e80000";

  public valorCheckbox: boolean = true;

  public colorSegmentosSeleccionados: string = "";

  public anioActual = new Date().getFullYear();
  public readonly CARRETERAS_FEDERALES: string = "1";

  constructor(
    private mapUtils: MapUtils,
    private ngbModalService: NgbModal,
    private cd: ChangeDetectorRef,
    private mapsAPILoader: MapsAPILoader,
    public dateUtils: DateUtils,
    public catalogoService: CatalogoService
  ) {}

  public ngOnInit() {
    this.obtenerCatalogos();
  }

  public obtenerCatalogos() {
    this.catalogoService
      .obtenerElementoDeCatalogoPorKey<ElementoCatalogo>(
        RutaCatalogoEnum.COLORES,
        this.KEY_COLOR_CAPA_COMPLETADO
      )
      .pipe(take(1))
      .toPromise()
      .then((colorCompletado: ElementoCatalogo) => {
        this.hexColorCapaCompletado = colorCompletado.nombre;
      });
  }

  async ngOnChanges(): Promise<void> {
    await this.mapsAPILoader.load();
    if (this.map) {
      //Se valida que el mapa este pintado en pantalla para poder centrar las polylines
      this.mapUtils.centrarArregloDePolylines(
        this.map,
        this.crearArregloPolylines(this.datosObra.capasSegmentos)
      );
    }
    this.iconoInicioFin = {
      url: "../../../../../assets/img/iconos/marker-red.png",
      scaledSize: {
        width: 25,
        height: 25,
      },
      labelOrigin: new google.maps.Point(0, 0),
    };
    this.cd.detectChanges();
  }

  public abrirModalGaleria(archivosSeleccionados: ArchivoCoordenada[]) {
    this.archivosSeleccionados = archivosSeleccionados;
    this.refModalGaleria = this.ngbModalService.open(this.modalGaleria, {
      size: "lg",
      centered: true,
      windowClass: "modal-lev-web",
      backdrop: "static",
      keyboard: false,
    });
  }

  public centrarMapa() {
    this.mapUtils.centrarArregloDePolylines(
      this.map,
      this.crearArregloPolylines(this.datosObra.capasSegmentos)
    );
  }

  public mouseOver(event: any, infoWindow: InfoWindow, avance: AvanceDTO): any {
    this.coordenadaInfoWindow = {
      latitud: event.latLng.lat(),
      longitud: event.latLng.lng(),
    };
    if (this.infoWindowActual && this.infoWindowAbierto) {
      this.infoWindowActual.close();
    }
    this.infoWindowActual = infoWindow;
    infoWindow.open();
    this.infoWindowAbierto = true;
    this.colorSegmentosSeleccionados = this.COLOR_PARA_RESALTAR;
    setTimeout(() => {
      this.avanceSeleccionado = avance;
      this.cd.detectChanges();
    }, 10);
  }

  public infoWindowClose(): void {
    if (this.avanceSeleccionado && this.infoWindowAbierto) {
      this.colorSegmentosSeleccionados = this.hexColorCapaCompletado;
    }
    this.avanceSeleccionado = null;
    this.infoWindowAbierto = false;
    setTimeout(() => {
      this.cd.detectChanges();
    }, 10);
  }

  public onPropertyChange(valor: boolean, keyCatCapa: string): void {
    if (keyCatCapa === this.CAPA_COMPLETADO) {
      this.datosObra.avances.forEach((avance: AvanceDTO) => {
        avance.mostrarCapa = valor;
      });
    }

    this.datosObra.capasSegmentos.forEach((capaSegmentos: CapaSegmentosDTO) => {
      if (capaSegmentos.capa.keyCatCapa === keyCatCapa) {
        capaSegmentos.mostrarCapa = valor;
      }
    });
  }
  public mapReady(event: any): void {
    this.map = event;
    this.mapUtils.centrarArregloDePolylines(
      this.map,
      this.crearArregloPolylines(this.datosObra.capasSegmentos)
    );
    this.coordenadaInicial = this.mapUtils.obtenerCoordenadaInicialArregloPolylines(
      this.crearArregloPolylineProyecto()
    );
    this.coordenadaFinal = this.mapUtils.obtenerCoordenadaFinalArregloPolylines(
      this.crearArregloPolylineProyecto()
    );
  }

  public crearArregloPolylines(capasSegmentos: CapaSegmentosDTO[]): any {
    let coordenadas: Array<Coordenada[]> = new Array<Coordenada[]>();
    capasSegmentos.forEach((capaSegmento) => {
      capaSegmento.segmentos.forEach((segmento: Segmento) => {
        coordenadas.push(segmento.coordenadas);
      });
    });
    return coordenadas.map((coordenadas: Coordenada[]) =>
      this.crearPolyline(coordenadas)
    );
  }

  public crearArregloPolylineProyecto(): Array<Coordenada[]> {
    let capaProyecto: CapaSegmentosDTO = this.datosObra.capasSegmentos.find(
      (capa: CapaSegmentosDTO) =>
        capa.capa.keyCatCapa === this.CAPA_PROYECTO_PROCESO ||
        capa.capa.keyCatCapa === this.CAPA_PROYECTO_PLANEACION
    );
    let segmentos: Array<Coordenada[]> = capaProyecto.segmentos.map(
      (segmento: Segmento) => segmento.coordenadas
    );
    return segmentos;
  }

  public crearPolyline(points: Coordenada[]): any {
    return {
      googlePolylinePoints: points.map((p) => ({
        lat: p.latitud,
        lng: p.longitud,
      })),
    };
  }

  public cambiarCapaFederales(nombreCapa: string) {
    if (this.datosObra.direccionAdjunta.key === this.CARRETERAS_FEDERALES) {
      if (nombreCapa === "Completado") {
        return "Terminado";
      } else if (nombreCapa === "Meta actual") {
        // return `Programado ${this.anioActual}`;
        return "Por modernizar";
      } else {
        return nombreCapa;
      }
    } else {
      return nombreCapa;
    }
  }
}
